<template>
	<div id="app">
		<template v-if="isFull">
			<nav-header id="nav-header" class="fixed" />
			<div id="view">
				<router-view></router-view>
			</div>
			<nav-footer id="nav-footer" />
		</template>
	</div>
</template>

<script>
import navHeader from './components/nav-header.vue';
import navFooter from './components/nav-footer.vue';
import { mapActions } from 'vuex';
export default {
	name: 'App',
	components: {
		navHeader,
		navFooter
	},
	data: () => {
		return {
			isFull: true
		};
	},
	mounted() {
		this.adjustViewMargin();
		window.addEventListener('resize', this.adjustViewMargin);
		setTimeout(this.adjustViewMargin, 400);
		const timeout = 1000;
		setTimeout(async () => {
			// await this.uiLoadUp(this.$route.query)
			this.loadScript("https://js.stripe.com/v3/")
			this.isLoading = false;
		}, timeout);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.adjustViewMargin);
	},
	watch: {
		$route() {
			this.$nextTick(() => {
				this.adjustViewMargin();
			});
		}
	},
	methods: {
		...mapActions(['recoverFromDixie']),
		adjustViewMargin() {
			const footer = document.getElementById('nav-footer');
			const view = document.getElementById('view');
			if (footer && view) {
				view.style.marginBottom = `${footer.offsetHeight - 80 / 2}px`;
			}
			setTimeout(() => {
				this.adjustHeaderMargin();
			}, 400);
			// this.adjustHeaderMargin();
		},
		adjustHeaderMargin() {
			const header = document.getElementById('nav-header');
			const view = document.getElementById('view');
			if (header && view) {
				view.style.marginTop = `${header.offsetHeight}px`;
			}
		},
		loadScript(scriptURI) {
			// This is necessary to force Vue to insert the cordova.js plugin.
			var script = document.createElement("script");
			script.setAttribute("src", scriptURI);
			script.setAttribute("type", "text/javascript");
			document.getElementsByTagName("head")[0].appendChild(script);
		}
	},
	async beforeMount() {
		this.isFull = false;
		await this.recoverFromDixie();
		this.isFull = true;
	}
}
</script>

<style lang="scss">
@import '@/scss/app.scss';

#app {
	position: relative;
	$safetyMargin: 80px;
	$boxShadow: 0 -4px 20px rgba(0, 0, 0, 0.3);
	$overflowShadow: 0 4px $safetyMargin rgba(0, 0, 0, 0.1);

	#nav-header {
		z-index: 15;
		box-shadow: $boxShadow;

		&.fixed {
			position: fixed;
			top: 0;
			width: 100%;
		}
	}

	#view {
		position: relative;
		min-height: calc(100vh - 8em);
		z-index: 10;
		background-color: white;
		box-shadow: $overflowShadow;
	}

	// #nav-header,
	.cv-rounded,
	#view {
		border-bottom-right-radius: 30px;
		overflow: hidden;
	}

	#nav-header {
		z-index: 15;
	}

	#view {
		position: relative;
		min-height: calc(100vh - 8em);
		z-index: 10;
		background-color: white;
	}

	#nav-footer {
		position: fixed;
		bottom: 0;
		width: 100%;
		z-index: 5;
		padding-top: $safetyMargin !important;

		h5 {
			text-transform: uppercase;
		}

		a:hover,
		a.router-link-active {
			text-decoration: none;
			color: $primary !important;
		}

		a.router-link-active {
			color: $secondary !important;
		}
	}
}
</style>